import type { SuggestionKind } from 'harper.js';
import type { Range, RangeRef } from 'slate';

export interface SpellcheckSuggestion {
  kind: SuggestionKind;
  text: string;
}

export interface SpellcheckLint {
  contextAfter: string;
  contextBefore: string;
  kind: string;
  message: string;
  problem: string;
  /**
   * Snapshot from the pass that found this problem. Used to match the same card across a
   * republish, not to paint or click: those read `rangeRef`.
   */
  range: Range;
  suggestions: SpellcheckSuggestion[];
  /**
   * Slate keeps this aligned with the document. Absent on lints built in tests that never go
   * through a pass. Null `current` means the text was deleted.
   */
  rangeRef?: RangeRef;
}

export const SPELLCHECK_STATUS = {
  loading: 'Loading…',
  off: 'Off.',
  ready: 'Ready.',
} as const;
